import type { RadioButtonGroupProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'

export default function RadioButtonGroup(props: RadioButtonGroupProps) {
  const { inputId, onChange, options, value } = props

  function handleChange(newValue: string) {
    if (!newValue.startsWith('index-')) return

    const parsedValue = Number.parseInt(newValue.slice(6), 10)

    onChange(parsedValue)
  }

  return (
    <InputFieldset {...props}>
      <RadioGroup
        name={inputId}
        onValueChange={handleChange}
        value={value !== null ? `index-${value}` : ''}
      >
        {options.map(option => {
          const itemId = `${inputId}-${option.value}`
          const labelId = `${itemId}-label`

          return (
            <div className='flex items-center gap-3' key={option.value}>
              <RadioGroupItem
                id={itemId}
                aria-labelledby={labelId}
                value={`index-${option.value}`}
              />
              <Label id={labelId} htmlFor={itemId} className='font-normal'>
                {option.label}
              </Label>
            </div>
          )
        })}
      </RadioGroup>
    </InputFieldset>
  )
}
